import React, { useState, useEffect } from "react"
import {
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Button,
} from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "./SuperResponsiveTableStyle.css"
import { Link } from "react-router-dom"
import Spinner from "../Spinner"
import QRCode from "qrcode.react"
import htmlToImage from "html-to-image"
import download from "downloadjs"

const APIserver = "https://hdform.herokuapp.com/api/facility/"

const RegistrationButton = () => {
  return (
    <Link to="/admin/facility/register">
      <Button color="primary">Register your Facility / Business</Button>
    </Link>
  )
}
const FacilityList = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  // Modal handlers
  const [open, setOpen] = useState(false)
  const [focusAfterClose, setFocusAfterClose] = useState(true)
  const showSuccessModal = () => setOpen(!open)
  const handleSelectChange = ({ target: { value } }) => {
    setFocusAfterClose(JSON.parse(value))
  }

  // Run on page load: Get Facility details
  const getFacilities = () => {
    setLoading(true)
    fetch(APIserver)
      .then((res) => res.json())
      .then((response) => setData(response))
      .then((res) => setLoading(false))
      .catch((err) => alert(err))
  }

  useEffect(() => {
    getFacilities()
  }, [])

  function QRModal(props) {
    // QR code to display response confirmation
    // Saving QR code to device
    const saveQR = () => {
      const canvas = document.getElementById("xx")
      htmlToImage.toPng(canvas).then(function (dataUrl) {
        download(dataUrl, `xxx.png`)
      })
    }

    // Redirect page on-close to other link
    const closeApp = () => {
      window.location.replace("/admin")
    }

    const FacilityQR = (props) => {
      return (
        <Container className="qr-top-padding">
          <QRCode
            bgColor="#ffffff"
            fgColor="#341f97"
            size={200}
            value={props.value}
            renderAs="canvas"
            level="L"
            className="img-responsive container-fluid"
            includeMargin={true}
          />
        </Container>
      )
    }
    return (
      <Container>
        <Modal returnFocusAfterClose={focusAfterClose} isOpen={open}>
          <ModalHeader className="success-modal-header text-center">
            SCAN ME
          </ModalHeader>
          <ModalBody id={"xx"} className="qr-confirmation">
            <FacilityQR />
            <Container className="qr-text text-center">
              <a href="https://hdform.now.sh" className="text-center qr-text">
                https://hdform.now.sh
              </a>
              <p className="qr-info">
                You may present this completion code to our security officer as
                proof of completion. You may now close this window.
              </p>
            </Container>
          </ModalBody>
          <ModalFooter>
            <Row>
              <Button onClick={saveQR}>Save QR</Button>
              <Button onClick={showSuccessModal}>Close</Button>
            </Row>
          </ModalFooter>
        </Modal>
      </Container>
    )
  }

  return (
    <div>
      <Container className="register-button">
        <RegistrationButton />
      </Container>
      {loading === true ? (
        <Spinner />
      ) : (
        <Table>
          <Thead>
            <Tr>
              <Th>Facility Name</Th>
              <Th>Email</Th>
              <Th>Mobile</Th>
              <Th>Address</Th>
              <Th>Visitors</Th>
              <Th>Created</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map((facility, index) => (
              <Tr key={index}>
                <Link to={`/admin/facility/${facility._id}`}>
                  <Td>{facility.facility_name}</Td>
                </Link>
                <Td>{facility.facility_email}</Td>
                <Td>{facility.facility_mobile}</Td>
                <Td>{facility.facility_address}</Td>
                <Link to={`/admin/facility/${facility._id}`}>
                  <Td>{facility.visitors.length}</Td>
                </Link>
                <Td>{new Date(facility.createdAt).toLocaleString()}</Td>
                <Td>
                  <Link to={`/admin/facility/qr/${facility._id}`}>View QR</Link>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </div>
  )
}

export default FacilityList
